module.exports = __webpack_public_path__ + "img/icon_feedback.6a292868.svg";